<template>
  <div class="current-task">
    <div class="current-task-inner">
      <table class="current-entry" v-if="!collapsed && currentEntry">
        <tr>
          <td class="duration" v-if="!$store.getters.pausedEntry" colspan="2">{{Number(currentEntry.duration).toFixed(1)}}</td>
          <td class="duration" v-if="$store.getters.pausedEntry" colspan="2">- - -</td>
        </tr>
        <tr v-if="timeRemaining && currentEntry">
          <td class="time-remaining" colspan="2">{{timeRemaining}} Remaining</td>
        </tr>
        <tr>
          <td class="client">{{currentEntry.client}}</td>

        </tr>
        <tr>
          <td class="project">{{currentEntry.projectPath}}</td>
        </tr>
        <tr>
          <td class="task">{{currentEntry.task && currentEntry.task.attributes.name}}</td>
        </tr>
      </table>
      <table>
        <tr>
          <el-tooltip placement="top-start" :content="currentEntry.projectPath" v-if="currentEntry">
              <td class="duration-collapsed" v-if="!$store.getters.pausedEntry && collapsed" colspan="2">{{Number(currentEntry.duration).toFixed(1)}}</td>
              <td class="duration-collapsed" v-if="$store.getters.pausedEntry && collapsed" colspan="2"> - -</td>
          </el-tooltip>
        </tr>
        <tr>
          <el-tooltip placement="right" v-if="timeRemaining && currentEntry" :content="timeRemaining + ' Remaining'" >
            <td class="time-remaining-collapsed" v-if="!$store.getters.pausedEntry && collapsed" colspan="2">{{timeRemaining}}</td>
          </el-tooltip>
        </tr>  
      </table>
      
      <div class="buttons" :class="{ column: collapsed }">
        <el-button type="danger" plain @click="stopCurrentTask(currentEntry)" v-if="currentEntry"><font-awesome-icon icon='stop'/></el-button>
        
        <el-button v-if="!$store.getters.pausedEntry && currentEntry" type="warning" plain @click="pauseCurrentTask(currentEntry)"><font-awesome-icon icon='pause'/></el-button>
        <el-button v-if="$store.getters.pausedEntry && currentEntry" type="success" plain @click="resumeCurrentTask(currentEntry)"><font-awesome-icon icon='play'/></el-button>
        
        <el-button type="success" plain @click="quickSwitch()"><font-awesome-icon icon='random'/></el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { setTimeEntryStopTime, startNewTimeEntry, getTimeEntryTask, mapTimeEntries } from '@/utils/timeEntry'
import { playSound } from '@/utils/sounds'
import { getCurrentEntry } from '@/utils/store'

export default {
  props: [
    'collapsed'
  ],
  data () {
    return {
      app: null,
      tray: null,
      interval: null
    }
  },
  methods: {
    stopCurrentTask (entry) {
      setTimeEntryStopTime(entry, 'now')
      playSound('negative')
    },
    pauseCurrentTask (entry) {
      setTimeEntryStopTime(entry, 'now')
      this.$store.commit('updatePausedEntry', entry)
      setTimeout(() => {
        getCurrentEntry()
      }, 200)
      getCurrentEntry()
    },
    resumeCurrentTask (entry) {
      this.$store.commit('updatePausedEntry', null)
      startNewTimeEntry(getTimeEntryTask(entry), 'now', entry.attributes.description)
    },
    quickSwitch () {
      startNewTimeEntry(null, 'now')
    },
    updateTrayIcon (currentEntry) {
      if (window && window.process && window.process.type) {
        const {app} = require('electron').remote
        this.app = app
        if (app && app.tray && app.menu) {
          this.tray = app.tray
          this.tray.setToolTip('Loading...')
          try {
            this.tray.setImage(app.path.join(__dirname, '../../src/renderer/assets/active.png'))
          } catch (e) {
            this.tray.setImage(app.path.join(__dirname, '../assets/active.png'))
          }
          const handleClick = (menuItem, browserWindow, event) => {
            if (menuItem.id === 1) {
              this.stopCurrentTask(currentEntry)
            } else if (menuItem.id === 2) {
              this.quickSwitch()
            }
          }
          let contextMenuTemplate = [{id: 0, label: 'Show Flux (ctrl + space)', type: 'normal', click: () => { app.show() }}, { id: 2, label: 'Quick Switch', type: 'normal', click: handleClick }]
          if (currentEntry) { // Handle if there is a current entry or not
            contextMenuTemplate.push({ id: 1, label: 'Stop Now', type: 'normal', click: handleClick })

            this.tray.setToolTip(currentEntry.client || '---' + ' | ' + currentEntry.projectPath || '---' + ' | ' + currentEntry.task.attributes.name || '---' + ' : ' + currentEntry.duration + 'h')
            this.tray.setContextMenu(app.menu.buildFromTemplate(contextMenuTemplate))
            try {
              this.tray.setImage(app.path.join(__dirname, '../../src/renderer/assets/active.png'))
            } catch (e) {
              this.tray.setImage(app.path.join(__dirname, '../assets/active.png'))
            }
          } else {
            this.tray.setToolTip('No current task')
            this.tray.setContextMenu(app.menu.buildFromTemplate(contextMenuTemplate))
            try {
              this.tray.setImage(app.path.join(__dirname, '../../src/renderer/assets/inactive.png'))
            } catch (e) {
              this.tray.setImage(app.path.join(__dirname, '../assets/inactive.png'))
            }
          }
        }
      }
    }
  },
  computed: {
    timeRemaining () {
      let ret = null
      if (this.currentEntry) {
        let duration = this.currentEntry.duration || 0
        ret = Number(Number(this.$store.getters.currentEntryHoursRemaining) - Number(duration)).toFixed(1)
      }
      if (Number(ret) < 0) ret = '0.0'
      return ret
    },
    currentEntry () {
      let user = this.$store.state.authentication.user
      let pausedEntry = this.$store.getters.pausedEntry
      let entries = this.$store.getters['time-entries/all'].filter(entry => entry.relationships.user && entry.relationships.user.data.id === user.id && !entry.attributes.end)
      let currentEntry = mapTimeEntries(entries)[0]
      this.$nextTick(() => this.updateTrayIcon(currentEntry))
      return currentEntry || pausedEntry
    }
  }
}
</script>

<style lang='scss' scoped>
@import '../styles/common.scss';

.current-task {
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  color: white;

  .current-task-inner {
    padding: 10px;
    
    .current-entry{
      width:100%;
      text-align: center;
      padding:5px;
    }
    .rule {
      margin: 10px 0px;
      width: calc(100% - 10px);
      padding: 0px;
      border-color: $light-red;
    }

    .duration {
      font-size: 60px;
    }
    .time-remaining, .time-remaining-collapsed{
      font-size:25px;
      color: $warning-color;
      text-align: center;
    }
    .duration-collapsed{
      font-size: 30px;
      padding: 5px 0px;
      width:80px !important;
      text-align: center;
    }
    .client{
      font-size: 25px;
      color: #67c23a;
    }
    .project{
      font-size: 18px;
      color: #409EFF;
    }
    .task{
      font-size: 14px;
      color: #909399;
    }
    .buttons {
      display: flex;

      &.column {
        flex-direction: column;
      }
      button {
        flex-grow: 1;
        margin: 2px 1px;
        padding: 12px 0px;

        &.hide {
          visibility: hidden;
        }
      }
    }
  }
}
</style>
